import React from "react";
import { AbCardWrapper } from "./style";
import { imgUrl } from "@/api/general";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function AbituriyentCard({ data }) {
  const { t } = useTranslation();

  return (
    <AbCardWrapper>
      <div className="container">
        {data?.map((v, i) => (
          <div key={i} className="card-item">
            <div className="right-item">
              <img src={imgUrl + v?.img} alt={v?.subtext || ""} />
            </div>

            <div className="left-item">
              <div className="top-item">
                <p>{v?.subtext}</p>
              </div>
              <div className="bottom-item">
                <Link to={`${v.id}`}>
                  <button>
                    {t("batafsil")}
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" strokeWidth="2.5"
                      strokeLinecap="round" strokeLinejoin="round">
                      <line x1="5" y1="12" x2="19" y2="12"/>
                      <polyline points="12 5 19 12 12 19"/>
                    </svg>
                  </button>
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </AbCardWrapper>
  );
}

export default AbituriyentCard;
